import { RematchDispatch, RematchRootState } from '@rematch/core';
import { connect } from 'react-redux';
import { RootModel } from '../../../../state';
import { SavedViewSelectionContainer } from './SavedViewSelectionContainer';

export const mapState = (state: RematchRootState<RootModel>) => ({
  projectId: state.projects.project.id,
  iModelId: state.imodels.iModel.iModelId,
  selected: state.imodels.iModel.defaultViewId,
});

export const mapDispatch = (dispatch: RematchDispatch<RootModel>) => ({
  setDefaultViewId: (defaultViewId: string) =>
    dispatch.imodels.setDefaultViewId(defaultViewId),
});

export const ConnectedSavedViewSelection = connect(
  mapState,
  mapDispatch
)(SavedViewSelectionContainer);
